<nav>
  <a routerLink="/lots">
    <div class="logo-section">
      <img class="logo" src="assets/images/logo.png" alt="Logo" />
      <p>Espace Client</p>
    </div>
  </a>
  <div class="links">
    <div class="dark-button" (click)="toggleTheme()" aria-label="Toggle dark/light mode">
      <mat-icon class="icon">wb_sunny</mat-icon>
    </div>
    <a *ngIf="authService.isAdmin()" routerLink="/clients">Clients</a>
    <a *ngIf="isLoggedIn()" routerLink="/lots">Mes Lots</a>
    <a *ngIf="isLoggedIn()" routerLink="/stats">Statistiques</a>
    <a *ngIf="isLoggedIn()" routerLink="/logout">Déconnexion</a>
  </div>
</nav>
